import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/common";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { Search, Plus, Phone, MapPin, Mail } from "lucide-react";

export default function Clienti() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const nav = useNavigate();

  const load = async (q = "") => { const { data } = await api.get(`/clients?search=${encodeURIComponent(q)}`); setItems(data); };
  useEffect(() => { load(); }, []);
  useEffect(() => { const t = setTimeout(() => load(search), 300); return () => clearTimeout(t); }, [search]);

  const save = async () => {
    if (!form.name) return toast.error("Nome obbligatorio");
    await api.post("/clients", form);
    toast.success("Cliente creato");
    setOpen(false); setForm({}); load(search);
  };

  return (
    <div>
      <PageHeader title="Clienti" subtitle={`${items.length} clienti registrati`}>
        <Button className="bg-brand hover:bg-[#A8472F] text-white" data-testid="btn-new-client" onClick={() => { setForm({}); setOpen(true); }}>
          <Plus size={16} className="mr-1" /> Nuovo cliente
        </Button>
      </PageHeader>

      <div className="relative mb-5">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="client-search" className="pl-10" placeholder="Cerca per nome, telefono o località…" value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      {items.length === 0 ? <EmptyState title="Nessun cliente" hint="Aggiungi il primo cliente già dal primo contatto." /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c) => (
            <button key={c.id} data-testid={`client-card-${c.id}`} onClick={() => nav(`/clienti/${c.id}`)} className="card-soft p-4 text-left lift">
              <p className="font-head font-bold">{c.name}</p>
              <div className="mt-2 space-y-1 text-sm text-muted-foreground">
                {c.phone && <p className="flex items-center gap-2"><Phone size={14} /> {c.phone}</p>}
                {c.locality && <p className="flex items-center gap-2"><MapPin size={14} /> {c.locality}</p>}
                {c.email && <p className="flex items-center gap-2"><Mail size={14} /> {c.email}</p>}
              </div>
            </button>
          ))}
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="client-dialog">
          <DialogHeader><DialogTitle className="font-head">Nuovo cliente</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {[["name","Nome *"],["phone","Telefono"],["email","Email"],["address","Indirizzo"],["locality","Località"]].map(([k,l]) => (
              <div key={k}><Label>{l}</Label><Input data-testid={`client-${k}`} value={form[k]||""} onChange={(e)=>setForm({...form,[k]:e.target.value})} /></div>
            ))}
            <div><Label>Note</Label><Textarea data-testid="client-notes" value={form.notes||""} onChange={(e)=>setForm({...form,notes:e.target.value})} /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={()=>setOpen(false)}>Annulla</Button><Button className="bg-brand text-white" data-testid="client-save" onClick={save}>Salva</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
